/* eslint-disable security/detect-non-literal-regexp, eslint-comments/disable-enable-pair, max-len, require-unicode-regexp, no-process-env */
const setSupportedBrowser = supportedBrowsers => ({ isSupportedBrowser: new RegExp(supportedBrowsers).test(navigator.userAgent) });

const environmentSetup = ({ supportedBrowsers }) => ({
  ...setSupportedBrowser(supportedBrowsers)
});

export default environmentSetup({
  supportedBrowsers: process.env.SUPPORTED_BROWSERS
});
